module.exports = [{"name":"cb-prime-site-validation","version":2},{"name":"FSC_SUMO5733","version":1},{"name":"PACO_PACO755","version":1}]